// src/mocks/handlers/filters/index.ts

import { filterCurrenciesHandler } from './filtersCurrencies';
import { filtersSourcesNetworksHandler } from './filtersSourcesNetworksHandler';

export const filtersHandlers = [
  filterCurrenciesHandler,
  filtersSourcesNetworksHandler,
];
